<template>
  <v-data-table
    :headers="_headers"
    :items="requests"
    :loading="loading"
    sort-by="requestSubmittedAt"
    sort-desc
  >
    <template v-slot:[`item.hoursApplied`]="{ item }">
      {{ item.pending ? "" : item.hoursApplied }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <view-request-action v-if="!item.pending" :request="item"></view-request-action>
      <edit-request-action v-if="item.pending" :request="item">
      </edit-request-action>
      <approve-deny-action
        v-if="item.pending"
        :request="item"
      ></approve-deny-action>
    </template>
  </v-data-table>
</template>
<script>
import ViewRequestAction from "./view-request-action.vue"
import EditRequestAction from "./edit-request-action.vue";
import ApproveDenyAction from "./approve-deny-action.vue";
export default {
  props: ["loading"],
  components: {
    ViewRequestAction,
    EditRequestAction,
    ApproveDenyAction,
  },
  data() {
    return {
      headers: [
        { text: "Request ID", value: "paidSickLeaveRequestId", align: "left" },
        { text: "Provider", value: "providerName" },
        { text: "Start Date", value: "formattedStartDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Hours Requested", value: "hoursRequested" },
        { text: "Hours Applied", value: "hoursApplied" },
        { text: "Reason", value: "reason" },
        { text: "Date Submitted", value: "formattedSubmittedDate" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    _headers() {
      // don't show Hours Applied on Open Requests route
      if (this.$router.currentRoute.name == "Open Requests") {
        return this.headers.filter((x) => x.value != "hoursApplied");
      }
      return this.headers;
    },
    requests() {
      return this.$store.state.paidSickLeaveModule.requests || [];
    },
  },
};
</script>